var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.149434 7.5904L19.9078 0.175278C19.9346 0.160343 19.9656 0.154617 19.9959 0.158981C20.0263 0.163344 20.0544 0.177556 20.0759 0.19943C20.0973 0.221304 20.1111 0.249632 20.1149 0.28006C20.1187 0.310487 20.1125 0.341333 20.0971 0.367856L15.9092 7.84814L19.9445 15.4214C19.9594 15.4482 19.9651 15.4791 19.9608 15.5095C19.9564 15.5399 19.9422 15.5679 19.9203 15.5894C19.8985 15.6109 19.8701 15.6246 19.8397 15.6285C19.8093 15.6323 19.7784 15.626 19.7519 15.6107L0.139956 7.8661C0.113351 7.85363 0.0909946 7.83362 0.0756602 7.80856C0.0603258 7.7835 0.0526893 7.75448 0.0536983 7.72512C0.0547073 7.69575 0.0643186 7.66733 0.0813378 7.64338C0.098357 7.61943 0.122036 7.60101 0.149434 7.5904Z",
    fill: "#1B1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.af39aa4edc6e515b56c1e03d97c14ec8.svg";
export { ForwardRef as ReactComponent };